import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import {
  apiShape,
  browserShape,
  displayUserName,
  notifierShape,
  NotFoundError,
  Loader,
  withApi,
  ActionBar,
  isNotEmpty,
  trackingShape,
  withBrowser,
  withNotifier,
  withTracking,
} from "lcm-iot-commons";

import AssetDetailsItem from "./AssetDetailsItem";
import UserDetailsItem from "./UserDetailsItem";
import PermissionRequestEdit from "./PermissionRequestEdit";
import { extractPermissionRequest } from "../../extractors/permissionRequestsExtractor";
import { extractAsset } from "../../extractors/assetsExtractor";

type OwnProps = {
  api: apiShape;
  browser: browserShape;
  notifier: notifierShape;
  match?: {
    params: {
      id: string;
    };
  };
  tracking: trackingShape;
};

const defaultProps: Partial<OwnProps> = {
  match: undefined,
};

type Props = OwnProps & typeof defaultProps;

export function PermissionRequest({
  api,
  match,
  notifier,
  browser,
  tracking,
}: Props) {
  const [permissionRequest, setPermissionRequest] = useState(undefined);

  const handleOnSubmitted = (newPermissionRequest: $TSFixMe) => {
    setPermissionRequest(newPermissionRequest);
  };

  const loadPermissionRequest = async () => {
    try {
      const permissionRequestResponse = await api.get(
        `/permission_requests/${(match as $TSFixMe)?.params.id}`,
      );
      const asset = await api.get(
        `/assets/${permissionRequestResponse.permitable.id}`,
        { include: "product.manufacturer,product.pictures" },
      );
      const currentPermissionRequest = extractPermissionRequest(
        permissionRequestResponse,
        extractAsset(asset),
      );
      // @ts-expect-error TS(2345) FIXME: Argument of type '{ id: any; status: any; requestU... Remove this comment to see the full error message
      setPermissionRequest(currentPermissionRequest);
      tracking?.trackEvent("PermissionsRequest-Details", {
        sn: currentPermissionRequest.permitable.serialNumber,
      });
    } catch (error) {
      if (error instanceof NotFoundError) {
        browser.navigateTo("/404");
      } else {
        notifier.showError(api.translateError(error));
        setPermissionRequest(undefined);
      }
    }
  };

  useEffect(() => {
    loadPermissionRequest();
  }, [(match as $TSFixMe)?.params?.id]);

  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-12">
          <ActionBar>
            <h1>
              <FormattedMessage id="permission_request.header" />
            </h1>
          </ActionBar>
        </div>
      </div>
      {permissionRequest ? (
        <div>
          <div className="row">
            <div className="col-sm-12">
              <p>
                <FormattedMessage
                  id="permission_request.info"
                  values={{
                    requestUser: displayUserName(
                      (permissionRequest as $TSFixMe).requestUser,
                    ),
                  }}
                />
              </p>
              <p>
                <FormattedMessage
                  id={`permission_request.info.${(permissionRequest as $TSFixMe).status}`}
                  values={{
                    responseUser: displayUserName(
                      (permissionRequest as $TSFixMe).responseUser,
                    ),
                  }}
                />
              </p>
              <h3>
                <FormattedMessage
                  id="permission_request.request_message_header"
                  values={{
                    user: displayUserName(
                      (permissionRequest as $TSFixMe).requestUser,
                    ),
                  }}
                />
              </h3>
              <p id="permission-request-message">
                {isNotEmpty((permissionRequest as $TSFixMe).requestMessage)
                  ? (permissionRequest as $TSFixMe).requestMessage
                  : "-"}
              </p>
              {(permissionRequest as $TSFixMe).status !== "open" ? (
                <div>
                  <h3>
                    <FormattedMessage
                      id="permission_request.response_message_header"
                      values={{
                        user: displayUserName(
                          (permissionRequest as $TSFixMe).responseUser,
                        ),
                      }}
                    />
                  </h3>
                  <p id="permission-response-message">
                    {isNotEmpty((permissionRequest as $TSFixMe).responseMessage)
                      ? (permissionRequest as $TSFixMe).responseMessage
                      : "-"}
                  </p>
                </div>
              ) : null}
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <AssetDetailsItem
                // @ts-expect-error TS(2322) FIXME: Type '{ asset: any; }' is not assignable to type '... Remove this comment to see the full error message
                asset={(permissionRequest as $TSFixMe).permitable}
              />
            </div>
            <div className="col-sm-12">
              <UserDetailsItem
                // @ts-expect-error TS(2322) FIXME: Type '{ user: any; }' is not assignable to type 'I... Remove this comment to see the full error message
                user={(permissionRequest as $TSFixMe).requestUser}
              />
            </div>
          </div>
          {(permissionRequest as $TSFixMe).status === "open" ? (
            <div className="row">
              <div className="col-sm-12">
                <PermissionRequestEdit
                  permissionRequest={permissionRequest}
                  // @ts-expect-error TS(2322) FIXME: Type '{ permissionRequest: never; onSubmitted: (ne... Remove this comment to see the full error message
                  onSubmitted={handleOnSubmitted}
                />
              </div>
            </div>
          ) : null}
        </div>
      ) : (
        <Loader loading />
      )}
    </div>
  );
}

PermissionRequest.defaultProps = defaultProps;

export default withApi(
  withNotifier(withBrowser(withTracking(PermissionRequest))),
);
